export const APPLE_TEAM_ID = 'P6FFMH75H7'

export const IOS_BUNDLE_ID = 'com.medicalharbour.bioatlas'

export const APPLE_ASSOCIATION_PATH = '/.well-known/apple-app-site-association'

export const APP_LINK_PREFIX = '/app'

export const APP_LINK_AUTH_PATH = `${APP_LINK_PREFIX}/auth`

export const APP_LINK_ORIGIN = process.env.DOMAIN_URL ?? ''
